import { DEFAULT_LOCALE, formatDate, type AnyLocaleType } from '@featit/shared/i18n/core';

/**
 * The erasure date a person is shown, such as "7 October 2026", in their own language, region and time zone
 * (F-0224 §6; IN-6). It lives in its own module because the app-wide banner renders it on every screen,
 * and that banner should not pull the settings pane into the first bundle. A caller that is not yet
 * converted leaves the locale out and reads English.
 */
export function formatDeletionDate(iso: string, locale: AnyLocaleType = DEFAULT_LOCALE): string {
  return formatDate(locale, iso, { day: 'numeric', month: 'long', year: 'numeric' });
}
